// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-2KYM4","ttt":"index-ttt-16uR9"};